import { Logger } from "index";
import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { MentorStatusEnum } from "../Enums/MentorStatusEnum";
import { AppUrls } from "AppUrls";

export class POST_UpdateMentorStatusRequest {
    public mentorId: string = "";
    public statusType: MentorStatusEnum = MentorStatusEnum.Current;
}

export class POST_UpdateMentorStatusEndpoint extends Endpoint<Request, Response> {
    constructor() {
        super();
        this.verb(Http.Post);
        this.path(AppUrls.Server.Mentor.UpdateMentorStatus);
    }

    public async HandleRequestAsync(request: POST_UpdateMentorStatusRequest): Promise<any> {
        return request;
    }

    public async HandleResponseAsync(response: Response): Promise<any> {
        return response;
    }
}
